import { useEffect, useRef } from "react";

// IntersectionObserver-driven scroll reveal. Adds `.is-visible` to `.reveal`
// elements when they enter the viewport.
export const useReveal = () => {
  const observerRef = useRef(null);

  // Effect intentionally runs once on mount: the observer is keyed off the
  // current DOM, and there are no closure-captured props/state that change.
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    if (els.length === 0) return undefined;

    if (!("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("is-visible"));
      return undefined;
    }

    if (observerRef.current) observerRef.current.disconnect();

    const io = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );

    observerRef.current = io;
    els.forEach((el) => io.observe(el));

    return () => io.disconnect();
  }, []);
};
